module.exports = __webpack_public_path__ + "static/media/grid_screen_2.f74b6a00.jpg";